import { HTMLAttributes } from "react"
import clsx from "clsx"

const ErrorMessage = ({
  message,
  className,
  ...rest
}: HTMLAttributes<HTMLParagraphElement> & { message?: string | null }) => {
  if (!message) return null

  return (
    <p
      {...rest}
      className={clsx("text-sm leading-4 font-medium text-red-600", className)}
    >
      {message}
    </p>
  )
}

export default ErrorMessage
